import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { tipoPromocaoCliente, tipoPromocaoItem } from '../tipo-promocao-campanha';

@Component({
    selector: 'sgt-tipo-promocao-campanha-multiselect',
    templateUrl: './tipo-promocao-campanha-multiselect.component.html',
    styleUrls: ['./tipo-promocao-campanha-multiselect.component.less']
})
export class TipoPromocaoCampanhaMultiselectComponent implements OnInit {
    /** tipos selecionados */
    @Input() tipos: number[];
    /** Ao alterar a seleção dos tipos */
    @Output() tiposChange = new EventEmitter<number[]>();

    /** Se deve exibir a opção de selecionar a opção de tipo de promoção nulo, ou seja, para filtrar registros que não possuem nenhuma promoção */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar o tipo de promoção nulo */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção de nulo */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum tipo';
    @Input() checked = 'Tipo'
    @Input() checkedPlural = 'Tipos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos selecionados';
    @Input() searchEmptyResult = 'Nenhum tipo encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowCliente = true;
    @Input() isShowItem = true;
    // Options
    options: IMultiSelectOption[];


    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-tipo-promoca-campanha ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos de promoções para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        // Adicionando a opção de "Nenhuma Promoção"
        if (this.showNullOption) {
            selects.push({
                id: 0,
                name: 'Nenhuma Promoção'
            });

            selects.push({
                id: null,
                name: null,
                isLabel: true
            });
        }

        if (this.isShowCliente) {
            selects.push({
                id: tipoPromocaoCliente.id,
                name: tipoPromocaoCliente.nome,
                classes: 'multiselect-item-tipo-promocao-campanha multiselect-item-tipo-promocao-campanha-cliente'
            });
        }
        if (this.isShowItem) {
            selects.push({
                id: tipoPromocaoItem.id,
                name: tipoPromocaoItem.nome,
                classes: 'multiselect-item-tipo-promocao-campanha multiselect-item-tipo-promocao-campanha-item'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção da opção tipo de promoção nulo */
    private onChangeNullOption() {
        this.nullOption = this.tipos.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção dos tipos */
    onChange() {
        this.onChangeNullOption();
        this.tiposChange.emit(this.tipos);
    }
}
